import { classNames, Component, h, tag } from "omi";
import isEmpty from "lodash-es/isEmpty";

import { ProjectGrid } from "@/pages/portfolio/features/grid";
import { PortfolioTeaser } from "@/pages/portfolio/features/teaser";
import { PortfolioHeader } from "@/pages/portfolio/ui/header";
import { PortfolioStore } from "@/pages/portfolio/store";
import { NWAvatar, NWButton } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {};

@tag("pages-portfolio-pages-home")
export class PagesPortfolioHome extends Component<Props> {
  static css = [tailwind];

  private handleBackToMyPortfolio() {
    PortfolioStore.stopViewingOtherPortfolio();
  }

  render() {
    const isPortfolioEnabled = Store.features.hasFeature("app.portfolio");
    if (!isPortfolioEnabled) {
      return <PortfolioTeaser />;
    }

    const showAnonState = !Store.user.isLoggedIn.value && PortfolioStore.viewing.value == null;
    const documents = PortfolioStore.documents.signal.data.value ?? [];
    const isLoadingDocuments = PortfolioStore.documents.signal.isLoading.value;

    const isPortfolioOwner = PortfolioStore.isOwner();
    const showComingSoonStateGrid =
      !showAnonState && !isLoadingDocuments && !isPortfolioOwner && documents.length === 0;

    const showComingSoonStateHeader =
      !showAnonState &&
      !isLoadingDocuments &&
      !isPortfolioOwner &&
      isEmpty(PortfolioStore.portfolioTitle.value) &&
      isEmpty(PortfolioStore.portfolioDescription.value);

    if (showComingSoonStateHeader && showComingSoonStateGrid) {
      return (
        <div
          className={classNames(
            "w-full mx-auto px-6 max-w-screen-xl animate animate-fadeInFast bg-white grid grid-rows-3 space-y-12 h-screen py-12 sm:py-16",
          )}
        >
          {Store.user.isLoggedIn.value ? (
            <div className="mb-14 lg:mb-24 animate-in fade-in duration-300">
              <div className="flex items-center justify- gap-1">
                <NWButton
                  type="text"
                  size="fit"
                  icon="chevron-left"
                  iconSize="md"
                  onClick={this.handleBackToMyPortfolio}
                >
                  <NWAvatar />
                  <p class="font-semibold  ml-2">Back to my portfolio</p>
                </NWButton>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <div class="flex flex-col items-center justify-center mx-auto">
            <h3 className="text-4xl font-semibold break-words">My portfolio</h3>
            <h1 className="text-7xl sm:text-9xl !my-4 font-semibold uppercase text-center">Coming soon</h1>
          </div>
        </div>
      );
    }

    return (
      <div
        className={classNames(
          "w-full mx-auto px-6 max-w-screen-xl animate-in fade-in bg-white flex items-center justify-center flex-col py-12 sm:py-16 space-y-12",
          { "!space-y-24": showComingSoonStateGrid && !showComingSoonStateHeader },
        )}
      >
        <PortfolioHeader showAnonState={showAnonState} showComingSoonState={showComingSoonStateHeader} />

        {showComingSoonStateGrid ? (
          <h1 className="text-7xl sm:text-9xl !my-4 font-semibold uppercase text-center animate animate-fadeInFast">
            Coming soon
          </h1>
        ) : (
          <ProjectGrid documents={documents} isLoading={isLoadingDocuments} showAnonState={showAnonState} />
        )}
      </div>
    );
  }
}
